export default {"src":"/_next/static/media/scientific.bd2dffa8.svg","height":1024,"width":1024,"blurWidth":0,"blurHeight":0};